<template>
  <div class="row">
    <h3 class="title text-left">
      {{ title }}
    </h3>
    <div class="col-12">
      <el-table :data="reports">
        <el-table-column prop="id" label="신고 ID" />
        <el-table-column label="컨텐트 ID">
          <div slot-scope="props">
            <a href="javascript:void(0);" @click.stop="onClickContentId(props.row.contentId, props.row.commentContentId, props.row.namespace)">{{
              props.row.contentId
            }}</a>
          </div>
        </el-table-column>
        <el-table-column label="컨텐트 작성자">
          <div slot-scope="props">
            <a href="javascript:void(0);" @click.stop="onClickUserId(props.row.authorUserId)">{{ props.row.authorNickname }}</a>
          </div>
        </el-table-column>
        <el-table-column label="신고자">
          <div slot-scope="props">
            <a href="javascript:void(0);" @click.stop="onClickUserId(props.row.reporterUserId || props.row.userId)">
              {{ props.row.reporterNickname || props.row.userId }}
            </a>
          </div>
        </el-table-column>
        <el-table-column :formatter="(row) => row.types.map((type) => type.name).join(', ')" label="구분" />
        <el-table-column prop="etcDesc" label="기타 신고내용">
          <div slot-scope="props">
            <div v-if="props.row.hasImage">
              <img :src="props.row.etcDesc" />
            </div>
            <div v-else>
              {{ props.row.etcDesc }}
            </div>
          </div>
        </el-table-column>
        <el-table-column v-if="isCommentNamespace" prop="comment" label="댓글" />
        <el-table-column prop="stateName" label="상태" />
        <el-table-column prop="reportCount" label="누적 신고 횟수" />
        <el-table-column :formatter="(row) => $options.filters.formatDateTime(row.regTime)" label="신고 날짜" />
        <el-table-column v-if="showActions" :min-width="60" align="center" label="액션">
          <div slot-scope="props">
            <base-button @click.native="onClickApprove(props.$index, props.row)" class="btn-link" type="info" size="sm"> 승인 </base-button>
            <base-button @click.native="onClickReject(props.$index, props.row)" class="btn-link" type="danger" size="sm"> 반려 </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="internalPage" :pageCount="totalPages"></base-pagination>
    </div>
  </div>
</template>

<script>
import { BasePagination } from "@/components/index";
import { URLUtils } from "@/util/URLUtils";
import { ReportChannel } from "@/common/ReportChannels";
import { PathResolver } from "@/util/PathResolver";
import { BlipNamespace } from "@/common/BlipNamespace";
import { isJson } from "@/util/StringUtil";

export default {
  name: "ReportsTableView",
  components: {
    BasePagination,
  },
  async created() {
    await this.refreshReports();
  },
  data() {
    return {
      internalPage: this.currentPage,
      totalPages: 1,
      reports: [],
    };
  },
  computed: {
    isCommentNamespace: function () {
      return [
        ReportChannel.COLLECTION_COMMENT,
        ReportChannel.TOPIC_COMMENT,
        ReportChannel.RADAR_COMMENT,
        ReportChannel.TRIVIA_COMMENT,
        ReportChannel.CHITCHAT_COMMENT,
      ].includes(this.namespace);
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    namespace: {
      type: Number,
      required: true,
    },
    unitId: {
      type: Number,
      required: true,
    },
    status: {
      type: Array,
      required: true,
    },
    onApprove: {
      type: Function,
      required: true,
    },
    onReject: {
      type: Function,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    async getReports(page) {
      const query = URLUtils.objectToQueryString({
        namespace: this.namespace,
        unitId: this.unitId,
        state: this.status,
        page: page ? page : 1,
      });

      const result = await this.$axios.get(`/reports/namespaces/${this.namespace}?${query}`);
      this.reports = result.data.data;
      if (this.namespace === BlipNamespace.THREAD_COMMENT) {
        this.reports = this.reports.map((report) => {
          if (isJson(report.etcDesc)) {
            const meta = JSON.parse(report.etcDesc);
            report.authorUserId = meta.author.userId;
            report.authorNickname = meta.author.nickname;
            if (meta.images?.length > 0) {
              report.hasImage = true;
              report.etcDesc = window.Endpoints.imageServerUrl + meta.images[0].fileId;
            } else {
              report.hasImage = false;
              report.etcDesc = meta.message;
            }
          }
          return report;
        });
      }
    },
    async getReportCount() {
      const query = URLUtils.objectToQueryString({
        namespace: this.namespace,
        unitId: this.unitId,
        state: this.status,
      });

      const result = await this.$axios.get(`/reports/namespaces/${this.namespace}/pagingStats?${query}`);
      this.totalPages = result.data.data.totalPages;
    },
    async refreshReports(page) {
      await this.getReports(page);
      await this.getReportCount();
    },
    onClickApprove(index, report) {
      this.onApprove(report);
    },
    onClickReject(index, report) {
      this.onReject(report);
    },
    onClickContentId(contentId, commentContentId, namespace) {
      let exactContentId = contentId;
      if (this.isCommentNamespace) {
        exactContentId = commentContentId;
      }
      console.log(contentId, commentContentId, namespace);
      const nextPath = PathResolver.resolveContentDetailPath(namespace ? namespace : this.namespace, this.unitId, exactContentId);
      console.log(nextPath);
      this.$router.push(nextPath);
    },
    onClickUserId(userId) {
      this.$router.push(`/user/userDetail?userId=${userId}`);
    },
  },
  watch: {
    unitId: async function () {
      await this.refreshReports();
    },
    namespace: async function () {
      await this.refreshReports();
    },
    status: async function () {
      await this.refreshReports();
    },
    internalPage: async function () {
      this.$emit("pageChanged", this.internalPage);
    },
  },
};
</script>
<style lang="scss"></style>
